import logo100prevalor from '#app/assets/images/logos/logo-navbar.svg'
import { FunctionalReachCard } from './components/FunctionalCard'
import { FunctionalGraph } from './components/FunctionalGraph'
import { FunctionalHighlightCard } from './components/FunctionalHighlightCard'
import { FunctionalIcon } from './components/FunctionalIcon'

const functionalReachCards = [
	{
		title: 'Aseguradoras',
		titleColorClass: 'text-error-500',
		items: [
			<li className="font-inter">
				{' '}
				<strong>Gestiona los procesos</strong> de tu cadena de comercialización.
			</li>,
			<li className="font-inter">
				{' '}
				<strong>Comercializa tus productos</strong> en todas partes, en cada
				momento.
			</li>,
			<li className="font-inter">
				{' '}
				Ofrece <strong>productos personalizados</strong>.
			</li>,
			<li className="font-inter">
				Implementa <strong>acciones de remarketing</strong>.
			</li>,
		],
		graph: 'aseguradoras',
	},
	{
		title: 'Productores',
		titleColorClass: 'text-warning-500',
		items: [
			<li className="font-inter">
				<strong>Amplía tu cartera</strong> de productos, con múltiples
				aseguradoras.
			</li>,
			<li className="font-inter">
				Integra seguros a tus <strong>servicios</strong>.
			</li>,
			<li className="font-inter">
				Consolida la <strong>relación con tus clientes</strong> a través de
				nuevos canales.
			</li>,
			<li className="font-inter">
				<strong>Intégrate fácilmente</strong> con servicios y procesos de
				terceros.
			</li>,
		],
		graph: 'productores',
	},
	{
		title: 'Organizadores - Productores',
		titleColorClass: 'text-blue-500',
		items: [
			<li className="font-inter">
				Ofrece a tus clientes una <strong>experiencia 100% digital</strong>.
			</li>,
			<li className="font-inter">
				Implementa <strong>nuevos modelos de negocio</strong>.
			</li>,
			<li className="font-inter">
				Automatiza procesos e <strong>incrementa tus ventas</strong>.
			</li>,
			<li className="font-inter">
				Integra seguros a tus <strong>servicios</strong>.
			</li>,
		],
		graph: 'portal',
	},
]

export const benefitsCards: {
	icon: React.ReactNode
	content: React.ReactNode
}[] = [
	{
		icon: <FunctionalIcon variant="money-shield" />,
		content: (
			<p className="text-[16px]">
				<strong>Permite comercializar</strong> seguros obligatorios,
				microseguros y seguros.
			</p>
		),
	},
	{
		icon: <FunctionalIcon variant="expand-arrows" />,
		content: (
			<p className="text-[16px]">
				Posibilita la <strong>diversificación de la cadena comercial</strong>{' '}
				permitiendo la llegada al cliente final.
			</p>
		),
	},
	{
		icon: <FunctionalIcon variant="paper-check" />,
		content: (
			<p className="text-[16px]">
				Permite realizar <strong>cotizaciones</strong> tanto a los
				intermediarios como al público en general.
			</p>
		),
	},
	{
		icon: <FunctionalIcon variant="charning-laptop" />,
		content: (
			<p className="text-[16px]">
				<strong>Rápida implementación</strong> ante cambios en el mercado o en
				la forma de comercializar.
			</p>
		),
	},
	{
		icon: <FunctionalIcon variant="building" />,
		content: (
			<p className="text-[16px]">
				Se integra con <strong>entidades bancarias</strong> permitiendo la
				gestión del recaudo electrónico.
			</p>
		),
	},
	{
		icon: <FunctionalIcon variant="users-database" />,
		content: (
			<p className="text-[16px]">
				<strong>Base de datos</strong> para generar estadísticas, estudios de
				mercado y minimizar riesgos.
			</p>
		),
	},
]

export default function FunctionalReachSection() {
	return (
		<section className="bg-neutral-200 pt-[64px] pr-[20px] pb-[60px] pl-[20px] md:pt-[120px] md:pr-[120px] md:pb-[120px] md:pl-[120px]">
			<div className="mx-auto max-w-[1400px] bg-neutral-200">
				<div className="mb-[38px] flex w-full justify-center px-[20px] md:mb-[64px] md:px-0">
					<h1 className="text-center text-[24px] leading-[32px] font-medium text-blue-800 md:text-[40px] md:leading-[56px]">
						Conoce parte del alcance <br className="hidden md:block" />{' '}
						funcional de nuestra plataforma
					</h1>
				</div>

				<div className="mx-auto grid max-w-6xl grid-cols-1 justify-items-stretch gap-8 md:grid-cols-3">
					{functionalReachCards.map((card, index) => (
						<>
							<FunctionalReachCard
								key={index}
								title={card.title}
								titleColorClass={card.titleColorClass}
								items={card.items}
								footerLogo={
									<img src={logo100prevalor} alt="logo" className="h-6" />
								}
							/>
							<div className="block md:hidden">
								<FunctionalGraph
									variant={
										card.graph as 'aseguradoras' | 'productores' | 'portal'
									}
								></FunctionalGraph>
							</div>
						</>
					))}
				</div>

				{/* Gráficos funcionales */}
				<div className="mt-[94px] mb-[94px] hidden flex-col gap-[94px] md:flex">
					<FunctionalGraph variant="aseguradoras"></FunctionalGraph>
					<FunctionalGraph variant="productores"></FunctionalGraph>
					<FunctionalGraph variant="portal"></FunctionalGraph>
				</div>

				<div className="mx-auto mt-[64px] grid grid-cols-1 gap-3 md:mt-0 md:grid-cols-2">
					{benefitsCards.map((card, index) => (
						<FunctionalHighlightCard
							key={index}
							icon={card.icon}
							text={card.content}
							className="w-full"
						></FunctionalHighlightCard>
					))}
				</div>
			</div>
		</section>
	)
}
